<div *ngIf="!areConnected" class="errorScreen">
  <h2 *ngIf="showErrorContent">Network Connection Failed - Attempting to Reconnect</h2>
  <mat-spinner class="loadingSpinner"></mat-spinner>
</div>
<div *ngIf="browserSupported" class="das {{ toolbarVisible ? 'toolbar-visible' : '' }}">
  <das-header
    class="default-focus-style"
    (accessibilityToggle)="accessibilityToggle($event)"
    [accessibilityToggleChecked]="isToggleChecked"
  ></das-header>
  <div class="main-body" [class.default-focus-style]="showDefaultFocusStyle">
    <router-outlet></router-outlet>
  </div>
  <tses-accessibility-manager></tses-accessibility-manager>
</div>
<div *ngIf="!browserSupported">
  <h1>Unsupported browser detected</h1>
  <div>
    <p>You browser has been detected as Internet Explorer, which is unsupported for DAS 3.0.</p>

    <p>Please use Firefox ESR or Chrome instead.</p>
  </div>
</div>
